// When loading avatar fails loads the default avatar instead.
export default e => {
  e.target.src =
    'https://verde-azul-imoveis.s3.amazonaws.com/b36f1999-aada-4f0b-9fe8-21bdf419fef7.png';
};
